<template>
  <RegisterMain v-if="$userLoadStatus.value == 'loaded'" class="sf-container" />
</template>

<script lang="ts">
import RegisterMain from "@/components/register/RegisterMain.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: { RegisterMain },
});
</script>
